import API from "./api";

const MessageContactService = {
  creer: async (payload: { email: string; nom?: string; message: string; confidentiel: boolean }) => {
    const response = await API.post("/contact", payload);
    return response.data.donnees;
  },

  getAll: async () => {
    const response = await API.get("/contact");
    return response.data.donnees;
  },

  marquerLu: async (id: number) => {
    const response = await API.post(`/contact/${id}/lu`);
    return response.data.donnees;
  },

  delete: async (id: number) => {
    const response = await API.delete(`/contact/${id}`);
    return response.data.donnees;
  },
};

export default MessageContactService;
